<template>
  <main class="app-main">
    <!-- Is loading -->
    <section v-if="!criteriaListIsReady" class="wam-content full-width">
      <spinner class="l-flex-row--center l-align-center" width="200" height="200" />
    </section>

    <template v-else>
      <template v-if="transferListIsEmpty && !isLoading">
        <section class="wam-content full-width">
          <section class="l-flex-column is-empty zero-state">
            <p class="zero-state-message">
              Oh no 😕<br>
              There is no transfers available yet.<br>
              <router-link
                @click="changeViewName('Audiences')"
                :to="'/' + accountId + '/monitoring/audiences'"
              >
                Create one in the Audience page
              </router-link>
            </p>
          </section>
        </section>
      </template>
      <template v-else>
        <section
          class="wam-content monitoring monitoring-transfers"
          :class="{ 'is-selected': selectedTransferRowId !== null }"
        >
          <!-- MODAL - Delete transfer -->
          <div
            v-if="displayTransferConfirmationModal"
            class="overlay-close"
            @click="setDisplayModal({ item: 'transfer', display: false })"
          />
          <div
            v-if="displayTransferConfirmationModal"
            class="modal modal__small modal-delete"
          >
            <ConfirmationModal>
              <template #content>
                <div>
                  You are about to delete transfer
                  <span class="is-highlighted__danger">{{ deletedTransfer.transferId }}</span>
                </div>
                <div>Do you want to continue?</div>
              </template>
              <template #footer>
                <div class="footer-content l-flex-row--between">
                  <div
                    class="btn btn--medium"
                    @click="setDisplayModal({ item: 'transfer', display: false })"
                  >
                    Cancel
                  </div>
                  <div
                    class="btn btn--medium btn-rev btn-delete"
                    @click.once="deleteTransfer(deletedTransfer)"
                  >
                    Delete
                  </div>
                </div>
              </template>
            </ConfirmationModal>
          </div>

          <!-- Monitoring -->
          <Transfers />

          <TransferDetails :transfer-info="transferInfos" ref="details" />
        </section>
      </template>
    </template>
  </main>
</template>


<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'

//components
import Transfers from '@/components/monitoring-transfers/Transfers'
import TransferDetails from '@/components/monitoring-transfers/TransferDetail'
import ConfirmationModal from '@/components/common/confirmationModal'

import { isEmpty } from 'lodash'

export default {
    name: 'Monitoring',

    components: {
        Transfers,
        TransferDetails,
        ConfirmationModal
    },

    data() {
        return {
            displayMainMenu: false,
            loadingDeleteAudience: false
        }
    },

    computed: {
        // Call to state
        ...mapState('data/transfer', {
            transferList: state => state.transferList,
            isLoading: state => state.isLoading,
            transferInfos: state => state.transferInfos
        }),
        ...mapState('account', {
            accountId: state => state.accountId,
            userRole: state => state.userRole,
        }),
        ...mapState('ui/transfers', {
            selectedTransferRowId: state => state.selectedTransferRowId,
            displayTransferConfirmationModal: state => state.displayModal.transfer,
            deletedTransfer: state => state.deletedTransfer,
        }),

        // Call to getters
        ...mapGetters('data/transfer', ['getItemById']),
        ...mapGetters('ui/builder', ['criteriaListIsReady']),
        ...mapGetters('account', ['getIsMonitoringActionAllowed']),

        transferListIsEmpty() {
            return isEmpty(this.transferList)
        },

        monitoringActionAllowed() {
            return this.getIsMonitoringActionAllowed()
        },
    },
    methods: {
        // Call to actions
        ...mapActions('data/transfer', ['deleteTransfer', 'retrieveTransferInfos']),
        ...mapMutations('exports', ['setExportForm']),
        ...mapMutations('data/transfer', ['setTransferInfos']),
        ...mapMutations('ui/transfers', ['setDisplayModal']),

        changeViewName(name) {
            this.view_name = name
        },
        toggleMainActionMenu() {
            this.displayMainMenu = !this.displayMainMenu
        },
        exportDataForm(type) {
            this.setExportForm({
                display: true,
                type
            })
        },
        closeModal() {
            // this.setIsProcessing({ isProcessing: false })
            this.setDisplayModal({ item: 'transfer', display: false })
        },
    }
}
</script>
